export function addEvent(target: any, type: string, listener: Function, options: any = null) {
    target.addEventListener(type, listener);
}
export function removeEvent(target: any, type: string, listener: Function, options: any = null) {
    target.removeEventListener(type, listener);
}
